<template>
  <span>{{ getPhotographyLifecycleDisplayValue(inventory.photography_lifecycle) }}</span>
</template>

<script>
import {createNamespacedHelpers} from "vuex";

const {mapState} = createNamespacedHelpers('global');


export default {
  name: "PhotographyLifecycleDisplayWidget",
  props: {
    inventory: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState({
      photographyLifecycleOptions: state => state.photographyLifecycleOptions,
    }),
  },
  methods: {
    getPhotographyLifecycleDisplayValue(photographyLifecycle) {
      if (!photographyLifecycle || !this.photographyLifecycleOptions) {
        return photographyLifecycle;
      }
      const option = this.photographyLifecycleOptions.find(opt => opt.key === photographyLifecycle);
      return option ? option.value : photographyLifecycle;
    },
  }
}
</script>

<style scoped lang="scss">

</style>
